"use strict";

require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _usePrefixCls = require("../_utils/hooks/usePrefixCls");
var _teaComponent = require("@tencent/tea-component");
var _excluded = ["className", "style", "line", "children", "extra"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var ContentTip = function ContentTip(props) {
  var className = props.className,
    style = props.style,
    line = props.line,
    children = props.children,
    extra = props.extra,
    extraProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var textRef = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    showTip = _useState2[0],
    setShowTip = _useState2[1];
  (0, _react.useEffect)(function () {
    var ref = textRef.current;
    if (!ref) {
      return;
    }
    if (line && line != 1) {
      setShowTip(ref.scrollHeight > ref.offsetHeight);
    } else {
      setShowTip(ref.scrollWidth > ref.offsetWidth);
    }
  }, []);
  var prefixCls = (0, _usePrefixCls.usePrefixCls)("content-tip");
  var classes = (0, _classnames2.default)(prefixCls, className, (0, _defineProperty2.default)({}, "line".concat(line), line && line !== 1));
  var element = /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: classes,
    style: style
  }, extraProps, {
    ref: textRef
  }), extra, children);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, showTip && /*#__PURE__*/_react.default.createElement(_teaComponent.Tooltip, {
    title: children
  }, element), !showTip && element);
};
var _default = ContentTip;
exports.default = _default;